import { useMemo } from 'react';

import { getInitials } from 'modules/experience-core';

import { useMe } from './useMe';

export const useUserProfile = () => {
  const { data: user } = useMe();

  const profilePicUrl = useMemo(() => {
    let profilePicUrl;
    if (user && user.profile_photo) {
      profilePicUrl = user.profile_photo.url;
    } else if (user && user.profile_picture) {
      profilePicUrl = user.profile_picture.url;
    }
    return profilePicUrl;
  }, [user]);

  const email = useMemo(() => user && user.email, [user]);
  const initials = useMemo(() => user && getInitials(user.name?.first_name ?? ''), [user]);

  return {
    profilePicUrl,
    email,
    initials,
    firstName: user?.name?.first_name,
    lastName: user?.name?.last_name,
  };
};
